import { cellText } from "./cellValue";
import type { Column, ColumnFilter, FilterOption } from "./DataTableTypes";

const OPTION_LOCALE = "en";

/** The filter value meaning "not filtered". */
export const NO_FILTER = "";

/** The column's filter settings; `filter: true` means default settings. */
export function filterSpec<R>(col: Column<R>): ColumnFilter {
  return typeof col.filter === "object" ? col.filter : {};
}

/** Label of the column's filter pill. */
export function filterLabel<R>(col: Column<R>): string {
  return filterSpec(col).label || col.label;
}

export function filterableColumns<R>(columns: Column<R>[]): Column<R>[] {
  return columns.filter((c) => c.filter);
}

/** Distinct non-empty cell texts of the column, sorted alphabetically. */
function optionsFromRows<R>(rows: R[], col: Column<R>): FilterOption[] {
  const texts = new Set<string>();
  for (const row of rows) {
    const text = cellText(row, col);
    if (text) texts.add(text);
  }
  return [...texts].sort((a, b) => a.localeCompare(b, OPTION_LOCALE)).map((text) => ({ value: text, label: text }));
}

/** Options of every filterable column, keyed by column key: the fixed ones or those found in the rows. */
export function filterOptions<R>(columns: Column<R>[], rows: R[]): Record<string, FilterOption[]> {
  const options: Record<string, FilterOption[]> = {};
  for (const col of columns) options[col.key] = filterSpec(col).options ?? optionsFromRows(rows, col);
  return options;
}
